import axios from 'axios';
import {configApi} from '../../api/configApi';
import {router} from '../../main.js';
import {headers} from '../../api/headers';
import {store} from '../index';

export default {
  namespaced: true,
  state: {
       auditorios: [],
       auditorio: null,
       pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 0,
          sortBy: '',
          totalItems: 0,
          rowsPerPageItems: [1, 2, 4, 8, 16],
    },
    pages: 0,
    loading: false,
  },
  getters: {
    listAuditorios: (state,getters,rootState) => {
          return state.auditorios;
    },
    auditorio: (state,getters,rootState) => {
        return state.auditorio;
    },
    pagination(state,getters,rootState){
      return state.pagination;
    },
    pages(state,getters,rootState){
      return state.pages;
    },
    totalItemCount(state,getters,rootState){
        return state.pagination.totalItems;
    },
    loading(state,getters,rootState){
        return state.loading;
    },
  },
  mutations: {
        listAuditorios: (state,auditorios) => {
          state.auditorios = auditorios;
          state.pagination.totalItems = auditorios.total;
          state.pagination.page = auditorios.current_page;
          state.pagination.rowsPerPage = auditorios.per_page;
       },
      listAuditoriosSearch: (state,auditorios) => {
            if(auditorios != null){ 
                state.auditorios = auditorios;
            }else{
              state.auditorios = null;
            }
       },
      viewAuditorio(state,id){
        let auxAuditorio = state.auditorios.filter((item) => item.id == id);
        state.auditorio = auxAuditorio[0];
      },
      setAuditorio(state,auditorio){
          state.auditorio = auditorio;
      },
    pages(state){
         if (state.pagination.rowsPerPage == null ||
              state.pagination.totalItems == null) { 
              state.pages = 0;
          } 

        state.pages = Math.ceil(state.pagination.totalItems / state.pagination.rowsPerPage);
    },
  },
  actions: {
    listAuditorios({state,getters,commit,rootState}){
      state.loading = true;
      return axios.get(`${configApi.apiUrl}auditorio_all`,null,{headers: headers})
      .then(response => {
        //console.log('auditorio',response);
        
        commit('listAuditorios',response.data.data);
        commit('pages');
        state.loading = false;
      })
      .catch(error => {
        state.loading = false;
        swal("Error!", "Error al obtener los auditorios!", "error");
        console.error(error);
      });

    },
  newAuditorio({state,getters,commit,rootState},payload){
      // nombre
      // id_ciudad
      // id_departamento
      // id_pais
      // direccion
      // latitud
      // longitud
      // aforo
      store.dispatch('validateToken');
      return axios.post(`${configApi.apiUrl}auditorio`,payload,{headers: headers})
      .then(response => {
        /*swal("Exito!", "Se creo el auditorio correctamente!", "success");*/
        commit('setAuditorio',response.data.data);
        store.dispatch('auditorio/listAuditorios',state.pagination.page);
      })
      .catch(error => {
        swal("Error!", "Error al crear el auditorio!", "error");
        console.error(error);
      });
  },
  updateAuditorio({state,getters,commit,rootState},payload){
      // nombre
      // id_ciudad
      // id_departamento
      // id_pais
      // direccion
      // latitud
      // longitud
      // aforo
      store.dispatch('validateToken');
      axios.put(`${configApi.apiUrl}auditorio/${payload.id}`,payload,{headers: headers})
      .then(response => {
        swal("Exito!", "Se actualizo el auditorio correctamente!", "success");
        store.dispatch('auditorio/listAuditorios',state.pagination.page);
      })
      .catch(error => {
        swal("Error!", "Error al actualizar el auditorio!", "error");
        console.error(error);
      });
  },
  deleteAuditorio({state,getters,commit,rootState},auditorio){
    store.dispatch('validateToken');
    axios.delete(`${configApi.apiUrl}auditorio/${auditorio}`,null,{headers: headers})
     .then(response => {
        swal("Exito!", "Se elimino el auditorio correctamente!", "success");
        store.dispatch('auditorio/listAuditorios',state.pagination.page);
     })
     .catch(error => {
        swal("Error!","Error al eliminar el auditorio!","error");
     });
  },
    searchAuditorios({state,getters,commit,rootState},key){
      store.dispatch('validateToken');
      store.commit('changeLoader', true);
      axios.get(`${configApi.apiUrl}buscarAuditorio?nombre=${key}`,null,{headers: headers})
      .then(response => {
        commit('listAuditoriosSearch',response.data.data);
        store.commit('changeLoader', false);
      })
      .catch(error => {
        store.commit('changeLoader', false);
        swal("Error!", "Error al obtener los auditorios!", "error");
        console.error(error);
      });

    },
  },
}